import React, { useState, useEffect } from "react";
import logo from "../../assets/images/navbar/logo.png";
import connectIcon from "../../assets/images/navbar/connectIcon.png";
import Lines from "../../assets/images/navbar/Group1.png";
import Modale from "./modale";
import { RiSettingsFill, RiLuggageDepositFill } from "react-icons/ri";
import { MdGTranslate } from "react-icons/md";
import { HiUserCircle } from "react-icons/all";
import { Link, useNavigate } from "react-router-dom";
import "./offheader.css";
import { useDispatch } from "react-redux";
import { logout } from "../../store/auth/auth";
import { BsList } from "react-icons/bs";
import { toast } from "react-toastify";
import { Button, Offcanvas, Overlay } from "react-bootstrap";
import {updatePath} from '../../store/auth/auth'

// import Deposit_canva from "./deposit_canva";

function OffHeader() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  let loggedIn = sessionStorage.getItem("isLoggedIn");
  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
    toast.success("Successfully Logout");
  };
  const [theme, setTheme] = useState<null | string>("");
  const toggleThem = () => {
    if (theme === "dark-theme") {
      localStorage.setItem("theme", "light-theme");
      setTheme("light-theme");
    } else {
      setTheme("dark-theme");
      localStorage.setItem("theme", "dark-theme");
    }
  };
  useEffect(() => {
    if (localStorage.getItem("theme") == null) {
      document.body.className = "dark-theme";
      localStorage.setItem("theme", "dark-theme");
      setTheme("dark-theme");
    } else {
      document.body.className = localStorage.getItem("theme")!;
      setTheme(localStorage.getItem("theme"));
    }
  }, [theme]);
  const now = new Date();
  let Expire = now.getTime();
  let item = loggedIn && JSON.parse(loggedIn);

  return (
    <>
      <nav className="navbar navbar-expand-lg offnavbar-container p-0">
        <div className="container-fluid pos-sti p-0 me-2 me-lg-0">
          <Link
            className="navbar-brand p-0"
            onClick={() => {
              dispatch(updatePath('home'))
              
            }}
            to={"/"}
          >
            <img src={logo} alt="Virtual Exchange" className="img-fluid" />
          </Link>
          <button
            className="navbar-toggler border-white"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <BsList className="text-white" />
          </button>
          <div
            className="collapse navbar-collapse collapsing_nav"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <div className="dropdown_academy">
                  <div className="dropdown-content">
                    <ul className="navbar-nav me-auto d-flex flex-column justify-content-center align-items-start">
                    </ul>
                  </div>
                </div>
              </li>
            </ul>

            <div className="d-flex gap-2 nav_last_btns">
              {/* Deposit Button */}
              {loggedIn ? (
                <>{/* <Deposit_canva /> */}</>
              ) : (
                <>
                  <div className="d-flex gap-2 gap-lg-1 gap-xl-3 ms-auto nav_last_btns">
                    {item && item.expiry > Date.now() ? (
                      <>
                        <div className="dropdown">
                          <button className="bg-transparent border-0 outline-0">
                            <HiUserCircle className="user-icon" />
                          </button>
                          <div className="dropdown-content-ldmode">
                            <div>
                              <button
                                className="btn-Login"
                                onClick={() => {
                                  handleLogout();
                        dispatch(updatePath('login'))

                                }}
                              >
                                Logout
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <button
                        className="offbtn-Login"
                        onClick={() => {
                          navigate("/login");
                      dispatch(updatePath('login'))

                        }}
                      >
                        Login
                      </button>
                    )}
                  </div>
                  <button
                    className="btn-Register ms-md-1 ms-lg-0"
                    onClick={() => {
                      navigate("/register");
                      dispatch(updatePath('register'))
                      
                    }}
                  >
                    Register
                  </button>
                  <button
                    className="btn_connect_bg ms-md-1 ms-lg-0"
                    onClick={() => handleShow()}
                  >
                    <div className="btn_connect_icon_bg">
                    </div>
                    <div className="btn_connection_wallet">Connect Wallet</div>
                  </button>
                </>
              )}
              {/* Settings Button */}
              <div className="dropdown">
                <button className="bg-transparent border-0 outline-0">
                  <RiSettingsFill className="settings-icon" />
                </button>
                <div className="dropdown-content-ldmode">
                  <div className=" my-2 ">
                    <Link
                      className="nav-link"
                      aria-current="page"
                      to="/settings/twofa"
                    >
                      Twofactor
                    </Link>
                  </div>
                </div>
              </div>

              {/* Google Translate Button */}
              <button className="bg-transparent border-0 outline-0">
                <MdGTranslate className="settings-icon" />
              </button>

              <div className="form-check form-switch switch">
                    <input
                      className="form-check-input change light_mode mt-2"
                      onClick={() => toggleThem()}
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked"
                    />
                  </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default OffHeader;
